module.exports = "https://coursera_assets.s3.amazonaws.com/images/857ccb67de0652541a556ee0bfb464cb.png";